import { render, staticRenderFns } from "./ProjectSummaryDetails.vue?vue&type=template&id=71146c5e"
import script from "./ProjectSummaryDetails.vue?vue&type=script&lang=js"
export * from "./ProjectSummaryDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports